import type { TranslationLanguage } from '@gitbook/api-client';
import { allTranslationLanguages, translationLanguageDescriptors } from '@gitbook/app-translations';
import { createPalette, PaletteCommandType, type PaletteDef } from '@gitbook/react-uikit';
import { Emoji } from '@gitbook/spine-react';
import type { MaybePromise } from '@gitbook/util-ts';

/**
 * Create a palette to pick a language.
 */
export function createPickLanguagePalette({
    initialValue,
    onPick,
}: {
    initialValue: TranslationLanguage | null;
    onPick: (value: TranslationLanguage) => MaybePromise<void>;
}): PaletteDef {
    return createPalette({
        search: { placeholder: 'Select a language' },
        groups: [
            {
                key: 'languages',
                commands: allTranslationLanguages.map((language) => ({
                    type: PaletteCommandType.RADIO,
                    key: language,
                    title: translationLanguageDescriptors[language].label,
                    icon: <Emoji code={translationLanguageDescriptors[language].emoji} />,
                    selected: initialValue === language,
                    trigger: async () => {
                        await onPick(language);
                    },
                })),
            },
        ],
    });
}
